import React, { Suspense, lazy } from 'react';
import { ToastContainer } from "react-toastify";
// import Loader from "./Component/Loader/Loader";
import Routings from './Component/Routes&Layout';
// const Routings = lazy(() => import('./Component/Routes&Layout'));\


function App() {
  return (
    <>
      <ToastContainer />
        <Routings />
    </>
  );
}

export default App;
